import icon from 'vue-svgicon';

icon.register({
    'bold/arrow-button-circle-right': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M12 0a12 12 0 1 0 12 12A12.013 12.013 0 0 0 12 0zM8.253 17.571A.5.5 0 0 1 8 17.138V6.862a.5.5 0 0 1 .748-.435l8.993 5.139a.5.5 0 0 1 0 .868l-8.989 5.139a.5.5 0 0 1-.499-.002z"/>`,
    },
});
